import * as Sentry from '@sentry/browser';

export const getPaymentIntent = async (amount: number, receipt_email: string) => {
  const emailEncoded = encodeURIComponent(receipt_email);
  const url = `${import.meta.env.VITE_CLOUDFUNCTIONS_URI}/createPaymentIntent?amount=${amount}&receipt_email=${emailEncoded}`;
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  const res = await fetch(url, {
    method: 'GET',
    headers: myHeaders,
  });
  const data = await res.json();

  if (res.status === 200) {
    return data;
  } else {
    console.error(`ERROR: ${data.status} - ${data.message}`);
    Sentry.captureException(`ERROR CREATING PAYMENT INTENT: ${data.status} - ${data.message}`);
    alert(`ERROR: ${data.status} - ${data.message}`);
    return 'ERROR';
  }
};
